import React from 'react';
import { smallUppercase } from 'scy/text/styles.mod.scss';
import { right } from 'scy/utils.mod.scss';
import padding from 'scy/padding.mod.scss';

export default function FilterItemToggle({ children }) {
  return (
    <span
      className={`${smallUppercase} ${padding.top_xxs} ${
        padding.bottom_xxs
      } ${right}`}
    >
      {children}
    </span>
  );
}
